export default __webpack_public_path__ + "static/media/udemy_1.d17f1e13.jpg";